export default __webpack_public_path__ + "static/media/discover3.161fe09e.png";